module.exports = __webpack_public_path__ + "img/product_39.17f1be5.svg";